import React from 'react';
import { motion } from 'framer-motion';
export function AICapabilities() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-694">
      <div className="max-w-6xl mx-auto px-6" data-id="element-695">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-696">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-697">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-698">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-699">
                RateBrain Intelligence
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-50 mb-6" data-id="element-700">
                AI-powered pricing that protects your margins
              </h2>

              <p className="text-lg text-stone-400 leading-relaxed" data-id="element-701">
                RateBrain analyzes competitive pricing, demand patterns, and
                market intelligence to deliver optimal dynamic pricing for every
                group quote. Not a black box — transparent recommendations you
                can trust.
              </p>
            </div>

            {/* Right: Capabilities */}
            <div className="lg:col-span-8" data-id="element-702">
              <div className="border-t border-stone-700" data-id="element-703">
                <div className="py-6 border-b border-stone-700" data-id="element-704">
                  <div className="flex items-start gap-6" data-id="element-705">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-706">
                      01
                    </span>
                    <div data-id="element-707">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-708">
                        Dynamic Rate Optimization
                      </p>
                      <p className="text-stone-400" data-id="element-709">
                        Analyze real-time demand, seasonality, and competitive
                        set pricing to recommend optimal group rates. Maximize
                        RevPAR while staying competitive.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-710">
                  <div className="flex items-start gap-6" data-id="element-711">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-712">
                      02
                    </span>
                    <div data-id="element-713">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-714">
                        RFP Intelligence
                      </p>
                      <p className="text-stone-400" data-id="element-715">
                        Parse incoming RFPs from any format — email, PDF,
                        WhatsApp. Extract dates, rooms, budgets, and
                        requirements automatically in seconds.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-716">
                  <div className="flex items-start gap-6" data-id="element-717">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-718">
                      03
                    </span>
                    <div data-id="element-719">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-720">
                        Competitive Set Analysis
                      </p>
                      <p className="text-stone-400" data-id="element-721">
                        Monitor competitor pricing across your market. Know
                        exactly where you stand and when to adjust. Real-time
                        rate shopping intelligence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-722">
                  <div className="flex items-start gap-6" data-id="element-723">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-724">
                      04
                    </span>
                    <div data-id="element-725">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-726">
                        Negotiation Copilot
                      </p>
                      <p className="text-stone-400" data-id="element-727">
                        AI-powered counter-offer suggestions that protect
                        margins while maximizing close probability. Enforce
                        pricing consistency across your team.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6" data-id="element-728">
                  <div className="flex items-start gap-6" data-id="element-729">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-730">
                      05
                    </span>
                    <div data-id="element-731">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-732">
                        Predictive Analytics
                      </p>
                      <p className="text-stone-400" data-id="element-733">
                        Close-probability scoring, demand forecasting, and price
                        elasticity modeling. Know which groups to prioritize and
                        when to flex on rate.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}